"use strict";
/**
 * @module html-ellipsis
 * @version 2.0.0
 * @exports htmlEllipsis
 *
 * @copyright 2014-2020 Alex Gherghisan
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlEllipsis = void 0;
const html_ellipsis_1 = require("./html-ellipsis");
Object.defineProperty(exports, "htmlEllipsis", { enumerable: true, get: function () { return html_ellipsis_1.htmlEllipsis; } });
exports.default = html_ellipsis_1.htmlEllipsis;
//# sourceMappingURL=index.js.map